export const formatImageSrc = (src: string | null) => {
  if (!src) return "";

  if (src.startsWith("blob") || src.startsWith("https")) {
    return src;
  } else {
    return `https://${src}`;
  }
};
